import { useMemo } from "react";
const useDiscountsDefaultValue = ()=>useMemo(()=>({
            label: '',
            value: '0'
        }), []);
export default useDiscountsDefaultValue;

//# sourceMappingURL=useDiscountsDefaultValue.js.map